import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class PostActivitySharedDTO {
  @ApiProperty()
  @IsOptional()
  Id?: number;
  @ApiProperty()
  @IsNotEmpty({message:"Post id should not be empty"})
  postId:number;
  @ApiProperty()
  @IsNotEmpty({message:"SharedBy should not be empty"})
  sharedBy:number;
  @ApiProperty()
  @ApiPropertyOptional()
  sharedWith?:number;
  createdAt : Date;
  @ApiProperty({
    description: 'api version number - type: integer',
    minimum:1,
    default:1
  })
  versionFlag : number;
}
